module.exports = __webpack_public_path__ + "static/media/ic_chevron_36.3ad1dc1d.svg";